import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { FormControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-input-currency',
  templateUrl: './input-currency.component.html',
  styleUrls: ['./input-currency.component.scss'],
})
export class InputCurrencyComponent implements OnInit {
  private _data = new BehaviorSubject<number>(0);
  @Input() set inputAmount(value: any) {
    this.transformAmount(value);
    this._data.next(value);
  }
  get inputAmount() {
    return this._data.getValue();
  }

  @Output() amountOutput = new EventEmitter<number>();

  public inputValue = new FormControl('');

  constructor() {}

  ngOnInit(): void {
    this.transformAmount(this.inputAmount);
  }

  onKeyup(value: any): void {
    //---improvement of currency amount---
    const cleanValue = value.toString().replace(/[^\d]/g, '');
    //---improvement of currency amount---

    if (cleanValue.length === 0) {
      return cleanValue;
    }
    this.transformAmount(cleanValue);
    this.amountOutput.emit(Number(cleanValue));
  }

  transformAmount(value: number) {
    let valueNew = Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 0,
    }).format(value);
    this.inputValue.setValue(valueNew);
    return valueNew;
  }
}
